<template>
    <block-section>
        <breadcrumb />
        <layout-split :headline="headline" reverse>
            <template v-slot:primary>
                <text-headline-secondary>
                    {{ texts.product_information_title }}
                </text-headline-secondary>

                <block-travel-information />
            </template>

            <template v-slot:secondary>
                <form @submit.prevent="nextStep">
                    <fieldset-customer-identification
                        v-if="deliveryMethod === 'email'"
                        class="group"
                        :validate="validate"
                        :title="texts.identification_title"
                        :description="texts.identification_description"
                        :link="texts.identification_link"
                        @linkClick="$modal.show('content-page-modal')"
                    />

                    <fieldset-customer-delivery
                        v-if="deliveryMethod === 'snailmail'"
                        class="group"
                        :validate="validate"
                        :title="texts.delivery_title"
                        :description="
                            $t(
                                'page_customer_information.delivery_description',
                                { days: shipmentDays }
                            )
                        "
                    />

                    <fieldset-customer-contact
                        class="group"
                        :validate="validate"
                        :title="texts.contact_title"
                        :description="
                            texts['contact_description_' + deliveryMethod]
                        "
                    />

                    <text-button
                        type="submit"
                        :disabled="validate && !isStepValid"
                    >
                        {{ texts.next_step_button }}
                    </text-button>

                    <modal-content-page name="WebshopTermsAndConditions" />
                </form>
            </template>
        </layout-split>
    </block-section>
</template>

<script>
import { mapGetters } from "vuex";
import {
    FLOW_TYPE_ZONE_TICKET,
    FLOW_TYPE_FIXED_PRICE_TICKET,
    FLOW_TYPE_RETIREE_TICKET
} from "@/store/modules/flow";
import TextButton from "@/components/elements/TextButton";
import BlockTravelInformation from "@/components/blocks/BlockTravelInformation";
import FieldsetCustomerIdentification from "@/components/fieldsets/FieldsetCustomerIdentification";
import FieldsetCustomerContact from "@/components/fieldsets/FieldsetCustomerContact";
import FieldsetCustomerDelivery from "@/components/fieldsets/FieldsetCustomerDelivery";

const ModalContentPage = () =>
    import(
        /* webpackMode: "lazy", webpackChunkName: "modal-content-page" */ "@/components/modals/ModalContentPage"
    );

export default {
    name: "PageCustomerInformation",
    components: {
        TextButton,
        ModalContentPage,
        BlockTravelInformation,
        FieldsetCustomerIdentification,
        FieldsetCustomerContact,
        FieldsetCustomerDelivery
    },
    data() {
        return {
            validate: false
        };
    },
    computed: {
        texts() {
            return this.$t("page_customer_information");
        },
        ...mapGetters({
            isStepValid: "flow/isStepValid",
            flowType: "flow/getType",
            deliveryMethod: "order/getDeliveryMethod",
            shipmentDays: "system/snailmailShipmentDelayDayCount"
        }),
        headline() {
            switch (this.flowType) {
                case FLOW_TYPE_FIXED_PRICE_TICKET:
                    return this.$t("page_new_fixed_price_ticket.title");
                case FLOW_TYPE_ZONE_TICKET:
                    return this.$t("page_new_zone_ticket.title");
                case FLOW_TYPE_RETIREE_TICKET:
                    return this.$t("page_new_retiree_ticket.title");
                default:
                    return "missing headline";
            }
        }
    },
    methods: {
        nextStep() {
            this.validate = true;
            if (this.isStepValid) this.$store.dispatch("flow/gotoNextStep");
        }
    }
};
</script>

<style scoped lang="scss">
.group {
    margin-bottom: 2rem;
}

@media (min-width: $breakpoint-tablet) {
    .group {
        margin-bottom: 1rem;
    }
}
</style>
